import CustomList from "components/list/custom";
import React from "react";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";
import { HoursCell } from "@/components/hours/cell";
import PercentageCell from "@/components/percentage/cell";
import TimesheetEmployeeFilters from "./filters";

const TimesheetEmployeesUtilization = () => {
  const filters = {
    type: "employee",
    startDate: CURRENT_MONTH_START_DATE,
    endDate: CURRENT_MONTH_END_DATE,
    department: null,
  };

  const [currentFilters, setCurrentFilters] = React.useState(filters);

  const columns = [
    {
      id: "name",
      accessorKey: "employeeFirstName",
      header: "Name",
      cell: ({ row }) => {
        const firstName = row.original.employeeFirstName;
        const lastName = row.original.employeeLastName;
        return (
          <div className="font-medium">
            {firstName} {lastName}
          </div>
        );
      },
    },
    {
      id: "department",
      accessorKey: "department",
      header: "Department",
      cell: ({ getValue }) => (
        <span className="capitalize">{getValue()?.name}</span>
      ),
    },
    {
      id: "availableHours",
      accessorKey: "availableHours",
      header: "Available Hours",
      cell: HoursCell,
    },
    {
      id: "totalLoggedHours",
      accessorKey: "totalLoggedHours",
      header: "Logged Hours",
      cell: HoursCell,
    },
    {
      id: "totalDraftHours",
      accessorKey: "totalDraftHours",
      header: "Draft Hours",
      cell: HoursCell,
    },
    {
      id: "totalApprovedHours",
      accessorKey: "totalApprovedHours",
      header: "Approved Hours",
      cell: HoursCell,
    },
    {
      id: "totalUnapprovedHours",
      accessorKey: "totalUnapprovedHours",
      header: "Unapproved Hours",
      cell: HoursCell,
    },
    {
      id: "totalNotReviewedHours",
      accessorKey: "totalNotReviewedHours",
      header: "Unreviewed Hours",
      cell: HoursCell,
    },
    {
      id: "utilizationPercentage",
      accessorKey: "utilizationPercentage",
      header: "Utilization",
      cell: PercentageCell,
    },
  ];

  const exportFields = [
    "id",
    "employee_id",
    "employeeFirstName",
    "employeeLastName",
    "department.name",
    "availableHours",
    "totalLoggedHours",
    "totalDraftHours",
    "totalApprovedHours",
    "totalUnapprovedHours",
    "totalNotReviewedHours",
    "utilizationPercentage",
  ];

  return (
    <div className="flex-1 overflow-auto">
      <CustomList
        endPoint="custom-ui/dashboard"
        filters={filters}
        onFiltersChange={setCurrentFilters}
        perPage={10}
        columns={columns}
        renderFilters={TimesheetEmployeeFilters}
        teleportFilters={true}
        title="Utilization"
        showSearch={true}
        storageKey={"employee"}
        export={true}
        fields={exportFields}
        href={(item) =>
          `${item.id}?filters=${encodeURIComponent(
            JSON.stringify({
              startDate: currentFilters.startDate,
              endDate: currentFilters.endDate,
            }),
          )}`
        }
      />
    </div>
  );
};

export default TimesheetEmployeesUtilization;
